var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "152.756,74.102 161.672,96.911 156.129,96.885 151.687,82.868  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "122.31,53.027 119.245,96.73 150.886,97.391 154.446,53.027  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAFAFA"
    },
    points: "125.475,56.546 122.924,92.923 146.446,94.025 149.732,56.33  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "130.637,61.69 128.729,87.26 141.704,87.26 143.993,61.69  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "91.103,97.004 91.103,75.123 107.127,75.123 107.127,96.987  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M100.213,75.123c0,0,3.865-28.251,2.782-28.211c-1.083,0.039-3.802,25.757-3.802,25.757 s-0.114-21.3-1.133-21.186c-1.02,0.113,0,22.546,0,22.546s-1.742-18.205-2.684-17.769c-0.942,0.435,0.404,18.864,0.404,18.864 H100.213"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M97.301,75.123c0,0,1.339-14.081,1.781-13.118c0.442,0.963,0,8.382,0,8.382 s3.71-18.195,4.682-17.577c0.972,0.618-3.798,19.749-3.798,19.749s3.621-10.922,4.416-9.771 c0.794,1.151-3.004,11.397-3.004,11.397s3.887-7.243,4.152-6.271c0.265,0.972-1.855,7.209-1.855,7.209H97.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M95.017,75.209c0,0-8.568-16.819-7.508-16.298c1.06,0.521,6.536,11.385,6.536,11.385 s-3.624-10.487-2.828-10.808c0.796-0.321,4.771,11.78,4.771,11.78l0.892,3.941H95.017z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "98.52,75.16 98.925,97.04 91.307,97.04 91.16,75.087  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "91.121,77.055 98.5,77.178 107.127,77.055 107.397,74.964 90.912,74.964  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 74.883,
    y: 96.394,
    style: {
      fill: "#E0E0E0"
    },
    width: 112.183,
    height: 5.778
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344.693,
    y: 102.599,
    style: {
      fill: "#FAFAFA"
    },
    width: 111.156,
    height: 194.477
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M379.318,298.941c0,0-12.175-87.496-18.557-97.11c0,0,36.417-27.344,37.533-101.449h-55.261 v198.559H379.318z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M421.207,298.554c0,0,12.175-87.496,18.557-97.111c0,0-36.417-27.343-37.533-101.448h55.261 v198.559H421.207z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M344.693,102.599"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182511079444078637790000005181051344437234323_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182511079444078637790000005181051344437234323_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M344.693,102.599L344.693,102.599L344.693,102.599z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M458.775,95.679h-5.152H334.388v3.059v4.35v194.495v3.207v3.206h129.54v-3.206v-3.207V95.679 H458.775z M367.035,203.909v49.538h-22.342v-49.538H367.035z M344.693,200.327v-51.27h22.342v51.27H344.693z M401.042,200.327 v-51.27h27.947v51.27H401.042z M428.989,203.909v49.538h-27.947v-49.538H428.989z M368.029,200.327v-51.27h29.431v51.27H368.029 z M397.461,203.909v49.538h-29.431v-49.538H397.461z M368.029,148.17v-45.082h29.431v45.082H368.029z M397.461,254.333v43.249 h-29.431v-43.249H397.461z M401.042,254.333h27.947v43.249h-27.947V254.333z M401.042,148.17v-45.082h27.947v45.082H401.042z  M429.983,203.909h23.64v49.538h-23.64V203.909z M429.983,200.327v-51.27h23.64v51.27H429.983z M453.623,148.17h-23.64v-45.082 h23.64V148.17z M367.035,103.088v45.082h-22.342v-45.082H367.035z M344.693,254.333h22.342v43.249h-22.342V254.333z  M429.983,297.582v-43.249h23.64v43.249H429.983z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M403.259,348.22c-4.922,0.792-7.122,6.84-6.692,11.807c0.43,4.967,2.472,9.822,1.926,14.777 c-0.694,6.293-5.449,11.612-6.003,17.918c-0.653,7.438,4.605,14.035,6.176,21.334c0.764,3.551,0.657,7.307,1.98,10.69 c2.23,5.705,8.768,9.368,14.798,8.292c6.03-1.077,10.895-6.778,11.012-12.902c0.109-5.711-3.415-11.09-2.987-16.786 c0.316-4.211,2.784-8.2,2.256-12.388c-0.629-4.984-5.247-8.523-6.877-13.275c-1.63-4.753-0.064-9.99-0.627-14.984 C417.212,353.746,412.245,347.501,403.259,348.22"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M378.125,391.593c-0.837,8.3,2.833,18.065,7.101,25.233c4.269,7.168,10.885,12.91,18.582,16.128 c0.868,0.363,1.949,0.668,2.679,0.076c0.598-0.486,0.673-1.358,0.678-2.129c0.059-8.734-2.784-17.464-7.974-24.489 C394,399.385,386.491,394.103,378.125,391.593"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M414.282,450.309c-0.015,0.006-0.096-0.154-0.236-0.462c-0.156-0.358-0.352-0.808-0.592-1.359 c-0.499-1.185-1.245-2.892-2.194-4.986c-1.895-4.19-4.705-9.894-8.241-15.954c-3.545-6.057-7.137-11.305-9.857-15.012 c-1.359-1.856-2.479-3.343-3.268-4.359c-0.362-0.479-0.658-0.871-0.893-1.183c-0.2-0.274-0.299-0.423-0.287-0.433 c0.013-0.01,0.137,0.118,0.361,0.373c0.254,0.298,0.572,0.671,0.963,1.129c0.834,0.983,1.996,2.44,3.392,4.274 c2.794,3.663,6.442,8.898,9.998,14.974c3.547,6.078,6.317,11.823,8.138,16.056c0.913,2.116,1.613,3.845,2.06,5.054 c0.207,0.564,0.376,1.025,0.51,1.392C414.246,450.132,414.297,450.303,414.282,450.309z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M408.938,371.183c0.017-0.001,0.047,0.273,0.09,0.796c0.041,0.564,0.096,1.326,0.166,2.286 c0.13,2.03,0.314,4.892,0.541,8.41c0.448,7.102,1.078,16.912,1.84,27.742c0.763,10.834,1.514,20.636,2.065,27.731 c0.269,3.515,0.487,6.374,0.643,8.403c0.065,0.96,0.118,1.723,0.156,2.286c0.031,0.523,0.039,0.798,0.022,0.8 c-0.016,0.001-0.056-0.272-0.117-0.792c-0.06-0.562-0.141-1.322-0.244-2.279c-0.191-2.026-0.461-4.882-0.792-8.392 c-0.636-7.089-1.44-16.889-2.203-27.725c-0.762-10.833-1.339-20.648-1.702-27.757c-0.164-3.522-0.297-6.387-0.391-8.42 c-0.033-0.962-0.058-1.726-0.078-2.29C408.921,371.46,408.922,371.184,408.938,371.183z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M401.304,438.472h20.787v15.261c0,5.512-4.467,9.978-9.978,9.978l0,0 c-5.304,0-9.681-4.149-9.964-9.446L401.304,438.472z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#EBEBEB"
    },
    d: "M294.604,192.719c-43.098-26.136,2.944-70.847-49.881-101.219 c-37.773-21.718-84.628-9.168-115.328,21.751c-30.7,30.919-38.2,82.833-30.5,125.719c7.7,42.886,24.208,81.109,58.716,107.711 c48.537,37.418,114.029,51.879,173.809,38.379c35.363-7.986,69.417-26.092,91.118-55.134c21.7-29.042,29.147-69.808,13.724-102.617 s-55.734-53.526-90.103-41.987c-8.638,2.9-16.626,7.564-25.364,10.145C312.057,198.048,301.867,198.221,294.604,192.719"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M457.779,463.282c0,0.144-90.781,0.26-202.738,0.26c-111.996,0-202.757-0.117-202.757-0.26 s90.761-0.26,202.757-0.26C366.999,463.022,457.779,463.138,457.779,463.282z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE9D"
    },
    d: "M106.62,450.183c0,0,25.219-80.099,25.754-82.7c0.484-2.35-9.152-59.993-10.366-74.911 l34.076,1.27c0,0,0.001,0.091,0.003,0.249l14.484,0.803l-12.973,163.817h-15.681l1.555-54.35 c-9.669,25.96-23.526,52.415-23.526,52.415L106.62,450.183z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB996E"
    },
    d: "M142.832,423.841c-0.014-0.497,0.19-18.21,0.19-18.21c0.196,1.06,6.012-15.379,5.871-16.379 C148.82,388.735,142.832,423.841,142.832,423.841z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB996E"
    },
    d: "M149.557,381.47c0.036-0.001,0.07,0.352,0.1,0.993c0.034,0.64,0.041,1.569-0.021,2.716 c-0.022,0.574-0.082,1.201-0.156,1.873c-0.086,0.67-0.178,1.389-0.333,2.134c-0.284,1.495-0.723,3.113-1.282,4.772 c-1.139,3.313-2.395,6.212-3.287,8.315c-0.423,0.959-0.786,1.784-1.091,2.477c-0.268,0.581-0.432,0.896-0.465,0.882 s0.067-0.354,0.277-0.958c0.21-0.604,0.53-1.472,0.938-2.539c0.805-2.138,2.007-5.059,3.135-8.343 c0.553-1.644,0.999-3.234,1.305-4.701c0.166-0.731,0.272-1.436,0.375-2.095c0.092-0.661,0.172-1.277,0.217-1.844 c0.108-1.131,0.157-2.053,0.185-2.69C149.486,381.824,149.521,381.47,149.557,381.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M171.808,325.098c0.605-22.839-1.961-46.496-3.991-53.671 c-0.193-0.684-0.36-1.375-0.525-2.067l-3.875-16.22c0,0-1.613-1.317,2.696-7.054c1.997-2.659,1.625-12.82,1.625-12.82 l-1.927,13.427l20.242-9.749c0,0-8.499-24.213-11.246-27.751c-7.131-9.184-20.014-7.577-20.014-7.577l-16.864-0.195 c0,0-6.436,0.406-12.584,3.284l-0.419,0.109l0.001,0.087c-4.834,2.359-9.145,6.328-10.386,12.8 c-2.024,10.555-1.388,15.366-1.388,15.366l13.739-0.245l-1.219,29.082c-1.039,3.579-3.94,2.721-8.232,19.251 c-1.765,6.8-2.833,13.247-3.456,18.997c-0.819,7.565-0.684,15.199,0.309,22.743l7.713,58.571h46.677L171.808,325.098z"
  }))))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#455A64"
    },
    points: "133.522,228.088 136.025,238.753 112.41,238.753 113.964,220.873  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M112.41,238.753c-0.003-0.07,1.19-0.195,3.126-0.309c1.935-0.114,4.613-0.209,7.573-0.196 c2.961,0.015,5.639,0.143,7.572,0.296c1.934,0.153,3.123,0.316,3.118,0.385c-0.006,0.075-1.204,0.042-3.138-0.017 c-1.934-0.059-4.604-0.129-7.555-0.143c-2.95-0.013-5.622,0.024-7.558,0.043C113.613,238.831,112.414,238.826,112.41,238.753z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.417,253.91c-0.031,0.004-0.096-0.363-0.138-1.04c0.02-0.337-0.008-0.758,0.09-1.233 c0.062-0.48,0.202-1.018,0.408-1.59c0.203-0.574,0.484-1.181,0.829-1.802c0.339-0.626,0.742-1.266,1.162-1.935 c0.845-1.333,1.765-2.8,2.333-4.497c0.268-0.852,0.448-1.701,0.495-2.542c0.06-0.839,0.014-1.658-0.073-2.432 c-0.168-1.552-0.53-2.926-0.851-4.069c-0.674-2.283-1.236-3.657-1.154-3.689c0.032-0.013,0.208,0.314,0.48,0.927 c0.272,0.613,0.646,1.51,1.025,2.652c0.37,1.143,0.775,2.528,0.976,4.121c0.103,0.794,0.161,1.641,0.106,2.52 c-0.042,0.88-0.23,1.785-0.51,2.674c-0.595,1.777-1.558,3.275-2.424,4.593c-0.432,0.662-0.843,1.287-1.19,1.889 c-0.354,0.599-0.644,1.176-0.861,1.721c-0.22,0.543-0.379,1.053-0.465,1.51c-0.122,0.453-0.123,0.859-0.174,1.186 C163.461,253.533,163.457,253.906,163.417,253.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M122.008,381.47c-0.008-0.003,0.023-0.117,0.092-0.337c0.081-0.245,0.187-0.567,0.321-0.974 c0.303-0.883,0.733-2.133,1.282-3.727c0.549-1.622,1.29-3.58,2.124-5.864c0.831-2.285,1.816-4.872,2.904-7.732 c2.207-5.718,4.829-12.512,7.74-20.053c1.451-3.776,2.973-7.739,4.551-11.847c1.579-4.108,3.164-8.38,4.788-12.755 c1.593-4.388,3.166-8.666,4.59-12.829c0.715-2.081,1.417-4.125,2.105-6.127c0.652-2.014,1.29-3.985,1.912-5.908 c1.287-3.834,2.287-7.545,3.337-10.984c0.486-1.73,0.905-3.415,1.337-5.027c0.407-1.618,0.875-3.152,1.172-4.652 c0.328-1.491,0.641-2.913,0.937-4.258c0.148-0.672,0.293-1.325,0.433-1.959c0.106-0.639,0.209-1.258,0.309-1.857 c0.197-1.196,0.381-2.31,0.551-3.338c0.17-1.026,0.345-1.961,0.393-2.815c0.158-1.677,0.281-2.991,0.368-3.919 c0.046-0.426,0.081-0.763,0.109-1.02c0.027-0.23,0.046-0.347,0.055-0.347c0.009,0,0.008,0.118-0.002,0.349 c-0.015,0.257-0.033,0.596-0.057,1.023c-0.064,0.932-0.155,2.252-0.272,3.935c-0.033,0.858-0.192,1.797-0.349,2.828 c-0.157,1.033-0.327,2.152-0.509,3.353c-0.093,0.602-0.19,1.224-0.29,1.866c-0.134,0.636-0.272,1.292-0.414,1.966 c-0.286,1.351-0.587,2.778-0.903,4.275c-0.286,1.506-0.744,3.045-1.141,4.669c-0.422,1.617-0.832,3.308-1.31,5.043 c-1.033,3.448-2.02,7.17-3.295,11.013c-0.618,1.928-1.251,3.903-1.898,5.921c-0.685,2.005-1.383,4.053-2.095,6.137 c-1.419,4.17-2.99,8.452-4.584,12.842c-1.625,4.377-3.214,8.65-4.8,12.757c-1.588,4.105-3.12,8.065-4.58,11.839 c-2.95,7.526-5.607,14.306-7.844,20.012c-1.101,2.85-2.097,5.43-2.975,7.702c-0.86,2.273-1.628,4.22-2.206,5.83 c-0.588,1.58-1.048,2.819-1.373,3.693c-0.154,0.4-0.277,0.716-0.37,0.956C122.065,381.364,122.016,381.473,122.008,381.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M134.54,220.786c0.072,0.003,0.097,1.039,0.079,2.713c-0.018,1.673-0.078,3.984-0.177,6.534 c-0.099,2.551-0.218,4.859-0.33,6.529c-0.112,1.67-0.217,2.701-0.289,2.698c-0.072-0.003-0.097-1.039-0.079-2.712 c0.018-1.673,0.078-3.984,0.177-6.535c0.099-2.55,0.218-4.858,0.33-6.528C134.363,221.814,134.468,220.783,134.54,220.786z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M155.836,237.08c0,0-5.057,31.857-19.811,30.827c0,0-6.643-0.079-8.779-4.494v-1.738 L155.836,237.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.417,253.141c0.004,0.144-3.199,0.38-7.155,0.529c-3.957,0.148-7.166,0.152-7.171,0.008 c-0.004-0.144,3.199-0.38,7.155-0.529C160.202,253.001,163.412,252.997,163.417,253.141z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.011,253.359c0.005,0.027-0.219,0.069-0.513-0.148c-0.297-0.209-0.545-0.666-0.792-1.18 c-0.284-0.589-0.579-1.202-0.887-1.842c-0.154-0.35-0.361-0.698-0.469-1.17c-0.111-0.453,0-1.112,0.562-1.411 c0.284-0.147,0.635-0.103,0.872,0.039c0.241,0.138,0.404,0.326,0.54,0.513c0.258,0.386,0.425,0.75,0.577,1.124 c0.295,0.741,0.422,1.452,0.463,2.047c0.071,1.199-0.179,1.911-0.234,1.896c-0.085-0.011,0.028-0.731-0.132-1.857 c-0.085-0.56-0.241-1.22-0.54-1.902c-0.147-0.334-0.334-0.701-0.547-1.008c-0.219-0.309-0.533-0.516-0.767-0.385 c-0.252,0.133-0.378,0.502-0.294,0.844c0.069,0.35,0.261,0.718,0.406,1.074c0.273,0.656,0.534,1.284,0.786,1.888 c0.211,0.55,0.38,0.961,0.591,1.18C157.835,253.283,158.021,253.316,158.011,253.359z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.043,253.897c-0.064-0.024,0.152-0.831,0.639-2.089c0.244-0.629,0.558-1.368,0.94-2.175 c0.191-0.403,0.4-0.822,0.625-1.253c0.113-0.219,0.25-0.461,0.47-0.671c0.202-0.215,0.639-0.38,0.99-0.181 c0.332,0.18,0.486,0.526,0.511,0.83c0.024,0.307-0.036,0.572-0.1,0.812c-0.122,0.49-0.304,0.944-0.52,1.351 c-0.439,0.813-1.005,1.438-1.543,1.87c-1.092,0.869-1.974,1.011-1.979,0.963c-0.038-0.086,0.773-0.353,1.737-1.241 c0.477-0.441,0.975-1.049,1.358-1.811c0.188-0.383,0.345-0.803,0.45-1.252c0.13-0.448,0.128-0.913-0.158-1.061 c-0.227-0.155-0.57,0.22-0.767,0.63c-0.221,0.419-0.435,0.827-0.645,1.225c-0.402,0.786-0.747,1.503-1.032,2.108 C158.452,253.163,158.114,253.923,158.043,253.897z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "134.54,223.079 137.364,242.157 135.536,245.504 133.299,239.018 133.799,238.928  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8505B"
    },
    d: "M157.893,459.52l0.007-1.473l-16.062-0.7l-0.044,6.075l0.991,0.067 c4.409,0.258,22.436,1.002,25.386,0.117C171.461,462.618,157.893,459.52,157.893,459.52z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M147.588,463.314c-0.223-1.336-0.962-2.579-2.029-3.413c-1.067-0.835-2.382-1.277-3.732-1.173 l-0.017,4.466L147.588,463.314z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M164.522,461.27c0,0,4.755,1.387,4.159,2.169 c-0.596,0.782-18.842,0.716-26.887-0.018l0.027-0.357l21.281,0.259C163.102,463.323,163.591,461.306,164.522,461.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M141.569,463.054c0,0.007,0.094,0.017,0.275,0.031c0.237,0.015,0.496,0.032,0.789,0.051 c0.789,0.037,1.759,0.082,2.904,0.136c2.453,0.097,5.843,0.186,9.589,0.203c3.747,0.016,7.139-0.044,9.592-0.119 c1.145-0.043,2.116-0.08,2.905-0.11c0.293-0.016,0.552-0.03,0.789-0.043c0.18-0.012,0.275-0.022,0.275-0.028 c0-0.007-0.095-0.01-0.276-0.011c-0.237,0.002-0.497,0.004-0.79,0.007c-0.79,0.013-1.76,0.029-2.906,0.048 c-2.453,0.041-5.843,0.078-9.588,0.063c-3.743-0.017-7.132-0.084-9.585-0.146c-1.145-0.029-2.116-0.054-2.905-0.074 c-0.293-0.005-0.553-0.01-0.79-0.014C141.664,463.045,141.569,463.047,141.569,463.054z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.096,463.572c0.059,0.008,0.107-0.686,0.548-1.384c0.428-0.706,1.027-1.059,0.994-1.108 c-0.011-0.048-0.697,0.251-1.159,1.007C163.009,462.836,163.048,463.583,163.096,463.572z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.39,461.162c0.045,0.029,0.272-0.245,0.506-0.611c0.235-0.366,0.388-0.687,0.343-0.716 c-0.045-0.029-0.271,0.245-0.506,0.611C158.498,460.813,158.345,461.133,158.39,461.162z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.098,460.473c0.036,0.04,0.288-0.128,0.565-0.374c0.276-0.246,0.471-0.479,0.436-0.518 c-0.036-0.04-0.288,0.127-0.565,0.374C157.258,460.201,157.063,460.433,157.098,460.473z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M156.286,458.962c-0.001,0.054,0.372,0.103,0.833,0.109c0.461,0.007,0.835-0.031,0.836-0.085 c0.001-0.053-0.372-0.102-0.833-0.109C156.661,458.871,156.287,458.909,156.286,458.962z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M156.009,457.897c-0.018,0.048,0.388,0.233,0.93,0.274c0.542,0.044,0.971-0.075,0.961-0.125 c-0.009-0.055-0.432-0.026-0.946-0.069C156.439,457.94,156.026,457.844,156.009,457.897z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.937,459.77c-0.001,0.022,0.393,0.071,1.027-0.003c0.316-0.037,0.691-0.111,1.094-0.237 c0.2-0.071,0.41-0.123,0.627-0.256c0.102-0.068,0.215-0.162,0.255-0.318c0.043-0.154-0.039-0.327-0.154-0.411 c-0.98-0.512-1.965,0.036-2.331,0.542c-0.202,0.258-0.294,0.51-0.337,0.684c-0.042,0.176-0.039,0.276-0.028,0.277 c0.036,0.013,0.071-0.404,0.471-0.874c0.197-0.23,0.496-0.454,0.879-0.567c0.363-0.106,0.879-0.133,1.224,0.088 c0.163,0.121,0.098,0.313-0.083,0.42c-0.169,0.108-0.388,0.174-0.578,0.245c-0.389,0.132-0.751,0.218-1.059,0.271 C159.328,459.739,158.937,459.738,158.937,459.77z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M159.203,459.822c0.015,0.011,0.167-0.25,0.121-0.712c-0.024-0.227-0.106-0.496-0.278-0.751 c-0.18-0.228-0.413-0.543-0.853-0.527c-0.238,0.03-0.355,0.3-0.318,0.473c0.018,0.18,0.098,0.335,0.173,0.459 c0.152,0.257,0.324,0.465,0.483,0.623c0.321,0.316,0.575,0.437,0.586,0.418c0.018-0.025-0.204-0.185-0.486-0.511 c-0.14-0.163-0.292-0.37-0.428-0.618c-0.14-0.218-0.235-0.608,0.022-0.653c0.257-0.024,0.519,0.233,0.675,0.438 c0.161,0.223,0.249,0.462,0.288,0.669C159.265,459.548,159.169,459.814,159.203,459.822z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M141.911,458.683c0.003,0.036,0.458-0.042,1.18,0.046c0.715,0.082,1.709,0.379,2.572,1.071 c0.862,0.693,1.367,1.6,1.601,2.28c0.242,0.686,0.264,1.146,0.299,1.142c0.012-0.001,0.018-0.116,0.002-0.322 c-0.016-0.207-0.064-0.505-0.171-0.862c-0.207-0.71-0.711-1.666-1.61-2.389c-0.9-0.721-1.942-1.007-2.68-1.056 c-0.372-0.027-0.674-0.01-0.879,0.019C142.02,458.64,141.909,458.671,141.911,458.683z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.604,461.781c-0.007,0.05,1.035,0.217,2.334,0.222c1.299,0.009,2.342-0.146,2.336-0.197 c-0.005-0.056-1.049,0.012-2.335,0.003C150.652,461.804,149.609,461.725,149.604,461.781z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M146.472,461.747c-0.039,0.039,0.085,0.221,0.19,0.461c0.109,0.238,0.163,0.452,0.218,0.449 c0.052,0,0.083-0.252-0.042-0.528C146.716,461.852,146.507,461.708,146.472,461.747z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M145.297,460.274c-0.038,0.037,0.064,0.204,0.229,0.372c0.165,0.168,0.329,0.274,0.367,0.237 c0.038-0.037-0.064-0.204-0.229-0.372C145.5,460.342,145.336,460.236,145.297,460.274z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M143.611,459.596c0.011,0.054,0.223,0.053,0.458,0.137c0.236,0.078,0.403,0.209,0.445,0.173 c0.043-0.029-0.091-0.257-0.382-0.356C143.84,459.449,143.595,459.547,143.611,459.596z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M142.41,459.275c-0.02,0.05,0.072,0.132,0.204,0.184c0.132,0.052,0.256,0.054,0.275,0.004 c0.02-0.05-0.072-0.132-0.204-0.184C142.552,459.227,142.429,459.226,142.41,459.275z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8505B"
    },
    d: "M120.26,458.103l0.61-1.341l-14.366-7.218l-2.528,5.524l0.876,0.467 c3.916,2.041,20.057,10.104,23.111,10.506C131.369,466.487,120.26,458.103,120.26,458.103z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M109.305,457.343c0.343-1.31,0.178-2.747-0.453-3.945c-0.631-1.198-1.649-2.141-2.924-2.599 l-1.845,4.067L109.305,457.343z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M125.591,462.415c0,0,3.769,3.213,2.905,3.682 c-0.864,0.469-17.482-7.065-24.521-11.03l0.171-0.315l19.308,8.953C123.454,463.706,124.727,462.066,125.591,462.415z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M103.921,454.64c-0.003,0.006,0.079,0.054,0.238,0.141c0.21,0.111,0.44,0.232,0.699,0.369 c0.705,0.357,1.571,0.796,2.594,1.313c2.198,1.093,5.254,2.564,8.664,4.113c3.412,1.549,6.53,2.884,8.799,3.82 c1.063,0.429,1.963,0.793,2.695,1.089c0.274,0.105,0.516,0.198,0.738,0.284c0.169,0.063,0.26,0.093,0.262,0.087 c0.002-0.006-0.083-0.048-0.247-0.123c-0.217-0.095-0.455-0.2-0.724-0.317c-0.726-0.311-1.618-0.694-2.671-1.146 c-2.255-0.968-5.363-2.322-8.772-3.87c-3.408-1.549-6.472-2.999-8.685-4.06c-1.033-0.496-1.908-0.916-2.62-1.258 c-0.265-0.125-0.501-0.236-0.715-0.337C104.012,454.671,103.924,454.634,103.921,454.64z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M123.348,463.93c0.051,0.031,0.379-0.582,1.067-1.039c0.68-0.469,1.371-0.545,1.361-0.604 c0.009-0.049-0.739-0.057-1.47,0.443C123.569,463.223,123.299,463.921,123.348,463.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M120.041,459.805c0.029,0.045,0.348-0.112,0.712-0.35c0.364-0.238,0.635-0.468,0.606-0.512 c-0.029-0.045-0.348,0.112-0.712,0.35C120.283,459.53,120.012,459.76,120.041,459.805z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M119.145,458.647c0.016,0.051,0.315,0.002,0.668-0.11c0.353-0.112,0.626-0.243,0.61-0.294 c-0.016-0.051-0.315-0.002-0.668,0.11C119.402,458.464,119.129,458.596,119.145,458.647z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M119.023,456.936c-0.023,0.049,0.298,0.246,0.715,0.441c0.418,0.195,0.775,0.314,0.798,0.266 c0.023-0.048-0.298-0.246-0.715-0.441C119.403,457.006,119.045,456.887,119.023,456.936z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M119.206,455.851c-0.036,0.036,0.259,0.371,0.736,0.631c0.476,0.262,0.917,0.33,0.928,0.28 c0.015-0.054-0.383-0.2-0.835-0.45C119.581,456.066,119.244,455.81,119.206,455.851z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M121.11,458.759c-0.01,0.019,0.329,0.226,0.938,0.418c0.304,0.096,0.675,0.182,1.095,0.232 c0.212,0.018,0.424,0.055,0.676,0.023c0.121-0.02,0.263-0.06,0.363-0.186c0.102-0.123,0.099-0.314,0.028-0.438 c-0.684-0.868-1.807-0.771-2.349-0.46c-0.29,0.153-0.477,0.345-0.588,0.486c-0.11,0.143-0.149,0.236-0.139,0.242 c0.027,0.027,0.23-0.34,0.788-0.605c0.274-0.129,0.638-0.212,1.034-0.157c0.375,0.052,0.857,0.239,1.08,0.581 c0.099,0.177-0.038,0.326-0.248,0.349c-0.199,0.03-0.425,0-0.628-0.014c-0.409-0.039-0.775-0.109-1.077-0.186 C121.48,458.891,121.123,458.73,121.11,458.759z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M121.332,458.915c0.009,0.016,0.255-0.16,0.402-0.6c0.071-0.217,0.106-0.496,0.055-0.799 c-0.071-0.282-0.154-0.665-0.563-0.83c-0.229-0.07-0.765,0.391-0.802,0.564c-0.057,0.172,0.271,0.083,0.287,0.228 c0.033,0.297,0.105,0.557,0.185,0.766c0.164,0.42,0.345,0.634,0.364,0.621c0.027-0.015-0.11-0.252-0.234-0.665 c-0.061-0.206-0.115-0.457-0.137-0.739c-0.039-0.256,0.034-0.651,0.288-0.587c0.244,0.084,0.378,0.425,0.436,0.676 c0.055,0.269,0.038,0.524-0.011,0.728C121.501,458.691,121.304,458.894,121.332,458.915z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M106.024,450.793c-0.012,0.034,0.435,0.149,1.058,0.525c0.619,0.368,1.404,1.046,1.908,2.031 c0.502,0.986,0.591,2.02,0.527,2.736c-0.061,0.725-0.229,1.154-0.195,1.164c0.011,0.004,0.064-0.098,0.133-0.294 c0.07-0.195,0.148-0.487,0.197-0.857c0.102-0.732,0.033-1.811-0.491-2.839c-0.525-1.027-1.359-1.715-2.012-2.061 c-0.328-0.177-0.61-0.285-0.81-0.342C106.141,450.799,106.027,450.781,106.024,450.793z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M111.772,456.77c-0.027,0.043,0.856,0.622,2.038,1.159c1.181,0.54,2.197,0.826,2.212,0.778 c0.018-0.053-0.961-0.419-2.132-0.954C112.719,457.221,111.801,456.721,111.772,456.77z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M108.93,455.457c-0.052,0.02-0.013,0.237-0.015,0.499c0.002,0.262-0.036,0.479,0.015,0.499 c0.047,0.021,0.179-0.196,0.178-0.499C109.109,455.652,108.977,455.435,108.93,455.457z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M108.461,453.631c-0.05,0.019-0.025,0.213,0.057,0.433c0.081,0.221,0.188,0.385,0.238,0.367 c0.05-0.018,0.025-0.213-0.057-0.434C108.618,453.777,108.511,453.613,108.461,453.631z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M107.2,452.323c-0.012,0.054,0.182,0.14,0.362,0.312c0.184,0.168,0.282,0.356,0.335,0.34 c0.051-0.009,0.023-0.272-0.203-0.482C107.47,452.282,107.206,452.271,107.2,452.323z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M106.236,451.538c-0.038,0.038,0.012,0.15,0.111,0.252c0.099,0.102,0.211,0.154,0.249,0.116 c0.038-0.037-0.012-0.15-0.111-0.252C106.386,451.552,106.274,451.5,106.236,451.538z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE9D"
    },
    d: "M166.748,208.918c0.134-1.336,0.397-3.138,0.459-3.968c0.188-2.531,0.619-3.094,1.462-2.718 c1.37,0.612-0.065,7.08,0.92,7.166c0.529,0.046,1.239-3.735,1.522-5.6c0.303-1.995,0.511-4.695,0.638-5.658 c0.139-1.061,1.944-1.304,1.878,0.578c-0.068,1.946-0.161,7.304,0.293,7.515c1.253,0.581,1.207-7.069,1.505-9.571 c0.066-0.556,0.191-0.947,0.345-1.219c0.431-0.761,1.609-0.474,1.727,0.392c0.332,2.439-0.154,9.027,0.031,10.095 c0.057,0.327,0.876,0.493,1.078-0.601c0.271-1.467,0.15-8.486,1.594-7.863c1.585,0.684-0.118,8.989,0.53,9.835 c1.209,1.575,1.345-7.451,2.844-7.059c0.759,0.198,0.742,0.482-0.028,5.301c-0.354,2.218-1.838,7.025-2.645,11.138 c3.478,12.271,9.566,35.254,8.676,42.83c-0.51,4.343-10.582,7.342-14.901,4.103c-4.319-3.239-7.326-17.661-7.326-17.661 l5.192-3.07l-5.075-27.802l0,0c-0.214-0.583-0.311-2.098-0.618-2.816C166.493,211.436,166.658,209.817,166.748,208.918z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB996E"
    },
    d: "M175.492,257.538c-0.141,0.028-0.895-3.224-1.685-7.261c-0.789-4.039-1.315-7.334-1.174-7.362 c0.141-0.028,0.895,3.223,1.685,7.262C175.108,254.214,175.633,257.51,175.492,257.538z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.119,190.466c4.399-0.637,8.864-0.818,13.299-0.537c0.69-1.239,0.799-2.787,0.288-4.11 c-0.511-1.323-1.631-2.396-2.975-2.85c-0.548-0.185-1.156-0.286-1.579-0.682c-0.684-0.639-0.587-1.74-0.356-2.648 c0.231-0.907,0.536-1.903,0.119-2.742c-0.652-1.311-2.561-1.335-3.623-2.344c-1.221-1.16-0.934-3.123-1.167-4.791 c-0.42-3.011-3.051-5.57-6.072-5.907"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M146.969,156.212c-4.928-1.194-10.509,1.269-12.946,5.715c-1.323,2.412-1.998,5.519-4.458,6.75 c-1.503,0.751-3.278,0.563-4.951,0.721c-1.673,0.158-3.559,0.934-3.958,2.567c-0.403,1.651,0.858,3.671-0.256,4.954 c-0.714,0.822-1.985,0.773-2.986,1.198c-2.032,0.862-2.608,3.499-2.388,5.695c0.221,2.196,0.95,4.419,0.433,6.564 c2.232,0.683,4.492,1.372,6.824,1.494s4.779-0.378,6.592-1.85c-0.193,0.956,0.428,1.934,1.264,2.437s1.842,0.627,2.816,0.688 c3.192,0.199,6.419-0.161,9.489-1.057"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE9D"
    },
    d: "M157.944,202.806c-0.065-4.169-0.125-8.294-0.125-8.294s6.744-0.661,7.224-7.512 c0.48-6.852,0.237-22.665,0.237-22.665l-12.204-6.283l-13.003,10.525l0.53,34.646c0.158,4.848,4.259,8.624,9.103,8.381l0,0 C154.374,211.37,158.017,207.479,157.944,202.806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.819,176.036c-0.005,0.485-0.392,0.873-0.865,0.868c-0.471-0.005-0.85-0.401-0.845-0.886 c0.005-0.485,0.392-0.874,0.864-0.869C163.445,175.155,163.824,175.551,163.819,176.036z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M164.657,175.089c-0.111,0.112-0.737-0.445-1.657-0.505 c-0.919-0.074-1.616,0.387-1.71,0.259c-0.047-0.057,0.071-0.265,0.375-0.474c0.299-0.209,0.803-0.397,1.376-0.356 c0.573,0.042,1.045,0.301,1.312,0.552C164.625,174.816,164.711,175.039,164.657,175.089z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M153.912,176.039c-0.005,0.485-0.392,0.873-0.865,0.868c-0.472-0.005-0.85-0.401-0.845-0.886 c0.005-0.485,0.392-0.874,0.864-0.869C153.538,175.158,153.917,175.555,153.912,176.039z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M154.453,175.089c-0.111,0.112-0.737-0.445-1.657-0.505 c-0.918-0.074-1.616,0.387-1.71,0.259c-0.046-0.057,0.07-0.265,0.375-0.474c0.299-0.209,0.803-0.397,1.375-0.356 c0.573,0.042,1.045,0.301,1.312,0.552C154.421,174.816,154.508,175.039,154.453,175.089z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.691,182.804c-0.002-0.056,0.575-0.123,1.507-0.187c0.236-0.01,0.461-0.045,0.508-0.214 c0.063-0.178-0.023-0.456-0.124-0.757c-0.195-0.624-0.398-1.278-0.612-1.964c-0.846-2.795-1.447-5.086-1.342-5.12 c0.105-0.034,0.876,2.204,1.722,4.999c0.203,0.689,0.397,1.345,0.582,1.974c0.077,0.292,0.215,0.627,0.079,0.996 c-0.071,0.184-0.25,0.308-0.402,0.342c-0.153,0.039-0.285,0.033-0.402,0.032 C158.271,182.895,157.692,182.86,157.691,182.804z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M129.855,174.849c0.075-0.485-0.066,0.527,0.029-0.234c0,0,0-0.004,0-0.004h0 c0.133-1.059,0.282-2.175,0.442-2.775c3.794-14.259,16.065-16.796,18.486-16.771c2.597,0.027,10.028-0.191,14.162,4.988 c5.458,6.836,2.366,13.606,2.366,13.606l0,0l-10.825-1.916c0.802-2.696-0.301-6.066-0.929-7.637l-0.062-0.06 c-2.056,10.242-13.095,12.541-13.095,12.541l-0.128,15.012C132.26,190.434,129.667,180.785,129.855,174.849L129.855,174.849z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE9D"
    },
    d: "M140.567,182.821c0.065-1.028,0.543-3.493,0.199-4.463c-0.344-0.97-1.422-1.19-2.609-1.179 c-1.185,0.011-2.609,1.103-2.567,2.562c0.035,1.184,0.428,2.402,1.445,3.011c1.016,0.61,2.325,0.63,3.427,0.191"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB996E"
    },
    d: "M139.287,181.47c-0.036-0.069-0.337,0.074-0.768-0.071c-0.436-0.118-0.872-0.63-0.889-1.338 c-0.016-0.347,0.069-0.666,0.243-0.816c0.178-0.161,0.458-0.2,0.679-0.182c0.462,0.053,0.784,0.186,0.813,0.108 c0.021-0.051-0.201-0.294-0.749-0.466c-0.273-0.07-0.671-0.097-1.042,0.172c-0.371,0.287-0.477,0.778-0.459,1.205 c0.016,0.442,0.171,0.863,0.429,1.167c0.253,0.309,0.607,0.471,0.895,0.507 C139.047,181.831,139.336,181.509,139.287,181.47z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.635,184.776c-0.048-0.043,0.172-0.307,0.64-0.204c0.217,0.047,0.5,0.242,0.587,0.575 c0.086,0.313,0.008,0.718-0.323,0.972c-0.343,0.242-0.756,0.192-1.028,0.007c-0.292-0.192-0.375-0.543-0.329-0.763 c0.094-0.482,0.45-0.558,0.46-0.492c0.04,0.061-0.124,0.227-0.093,0.512c0.016,0.14,0.082,0.27,0.218,0.336 c0.132,0.073,0.343,0.072,0.464-0.02c0.126-0.089,0.19-0.289,0.164-0.443c-0.019-0.153-0.122-0.268-0.246-0.339 C157.894,184.774,157.668,184.842,157.635,184.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M154.988,172.38c-0.033,0.149-1.041,0-2.222,0.279c-1.187,0.259-2.031,0.829-2.125,0.709 c-0.1-0.092,0.685-0.922,2.009-1.217C153.971,171.845,155.038,172.253,154.988,172.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M150.556,155.164c-0.007,0.048-0.407-0.011-1.127,0.005c-0.717,0.014-1.76,0.141-2.962,0.579 c-1.194,0.443-2.54,1.219-3.739,2.404c-1.202,1.179-2.215,2.78-2.924,4.599c-1.415,3.677-1.382,7.343-1.338,9.914 c0.045,1.211,0.083,2.238,0.114,3.076c0.026,0.728,0.026,1.132-0.01,1.135c-0.036,0.003-0.103-0.395-0.192-1.119 c-0.087-0.723-0.198-1.773-0.28-3.076c-0.076-1.303-0.123-2.865,0.013-4.597c0.133-1.73,0.481-3.636,1.207-5.521 c0.732-1.879,1.798-3.54,3.075-4.754c1.272-1.219,2.695-1.992,3.952-2.407c1.265-0.41,2.353-0.483,3.087-0.434 c0.368,0.028,0.651,0.063,0.84,0.11C150.462,155.116,150.559,155.146,150.556,155.164z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB996E"
    },
    d: "M158.56,194.363c0.009,0.061-0.598,0.227-1.611,0.3c-1.008,0.061-2.439,0.003-3.937-0.454 c-1.503-0.441-2.733-1.22-3.479-1.914c-0.756-0.694-1.073-1.25-1.026-1.285c0.065-0.054,0.479,0.41,1.261,1.001 c0.775,0.594,1.961,1.278,3.395,1.699C156.045,194.579,158.555,194.181,158.56,194.363z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE9D"
    },
    d: "M125.387,238.58l7.912,0.438c0.5,2.565,2.237,6.487,2.237,6.487 c6.368-11.054,11.306-25.865,12.532-31.817c-0.179-0.595-0.39-1.252-0.654-1.987c-0.305-0.849-0.043-2.455,0.101-3.347 c0.214-1.325,0.584-3.108,0.696-3.934c0.339-2.515,0.744-2.91,1.622-2.626c1.193,0.387-0.489,7.063,0.489,7.208 c0.526,0.078,1.168-2.21,1.355-4.086c0.187-1.877,1.035-7.65,1.655-8.035c0.91-0.564,1.702,0.328,1.472,2.197 c-0.232,1.892-0.526,7.533,0.466,7.609c0.977,0.075,1.798-9.496,1.798-9.496s-0.155-2.083,0.994-2.033 c2.071,0.09,0.453,10.181,0.276,11.137c-0.124,0.665,0.952,0.787,1.047,0.065c0.097-0.743,0.597-9.572,2.706-9.501 c1.619,0.055-1.254,8.315-0.345,10.23c0.909,1.915,1.54-6.504,3.086-6.388c0.575,0.044,1,0.156-0.057,4.92 c-0.568,2.56-2.237,7.268-3.696,11.166c-2.449,13.21-13.198,55.47-30.05,47.734c-9.43-4.328-13.83-25.76-13.83-25.76 L125.387,238.58z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB996E"
    },
    d: "M158.847,206.845c0,0-0.076,0.014-0.219-0.03c-0.129-0.04-0.384-0.2-0.344-0.528 c0.021-0.567,0.111-1.394,0.242-2.463c0.098-1.076,0.419-2.366,0.421-3.895c0.012-0.765-0.007-1.588-0.051-2.46 c-0.028-0.436-0.036-0.889-0.133-1.316c-0.072-0.414-0.349-0.888-0.669-0.831l-0.035,0.006l-0.016-0.001 c-0.325-0.015-0.579,0.238-0.684,0.626c-0.114,0.37-0.143,0.807-0.12,1.224l0.001,0.017l-0.001,0.012 c-0.214,2.339-0.444,4.899-0.977,7.633c-0.074,0.341-0.15,0.685-0.256,1.032c-0.053,0.173-0.114,0.348-0.19,0.524 c-0.049,0.09-0.08,0.176-0.155,0.271c-0.065,0.08-0.148,0.219-0.382,0.24c-0.38-0.028-0.489-0.316-0.575-0.48 c-0.082-0.19-0.133-0.376-0.171-0.562c-0.078-0.372-0.118-0.743-0.147-1.116c-0.101-1.491-0.049-3.013,0.061-4.573 c0.036-0.788,0.23-1.575,0.095-2.29c-0.063-0.352-0.21-0.707-0.45-0.853c-0.117-0.071-0.249-0.086-0.393-0.05 c-0.072,0.021-0.145,0.05-0.217,0.094c-0.06,0.058-0.047,0.032-0.101,0.135c-0.306,0.654-0.463,1.507-0.634,2.298 c-0.162,0.809-0.302,1.633-0.432,2.467c-0.128,0.834-0.247,1.678-0.346,2.528c-0.082,0.85-0.205,1.741-0.421,2.6 c-0.11,0.432-0.231,0.863-0.412,1.292c-0.093,0.215-0.189,0.427-0.377,0.646c-0.068,0.093-0.281,0.268-0.547,0.199 c-0.258-0.086-0.331-0.291-0.373-0.41c-0.148-0.526-0.105-0.963-0.097-1.423c0.02-0.454,0.057-0.902,0.095-1.35 c0.065-0.77,0.139-1.532,0.165-2.282c0.012-0.374,0.013-0.748-0.027-1.1c-0.022-0.172-0.052-0.349-0.111-0.477 c-0.027-0.065-0.063-0.112-0.088-0.136c-0.014-0.015-0.023-0.008-0.035-0.023l-0.119-0.034 c-0.606-0.251-0.808,0.593-0.969,1.273c-0.141,0.709-0.23,1.441-0.372,2.163c-0.241,1.44-0.548,2.871-0.709,4.246 c-0.066,0.681-0.115,1.39,0.08,1.967c0.216,0.661,0.43,1.315,0.642,1.961l0.019,0.059l-0.014,0.061 c-1.114,4.916-2.658,9.314-4.09,13.219c-1.447,3.901-2.894,7.272-4.172,10.029c-1.273,2.76-2.416,4.886-3.205,6.336 c-0.4,0.688-0.716,1.231-0.951,1.635c-0.221,0.368-0.341,0.556-0.353,0.549c-0.012-0.007,0.084-0.209,0.281-0.59 c0.218-0.413,0.511-0.968,0.881-1.67c0.743-1.472,1.841-3.614,3.072-6.385c1.236-2.768,2.644-6.145,4.058-10.047 c1.398-3.9,2.916-8.31,3.999-13.174l0.005,0.12c-0.211-0.638-0.425-1.283-0.64-1.935c-0.246-0.746-0.173-1.475-0.113-2.188 c0.164-1.43,0.462-2.819,0.701-4.266c0.141-0.715,0.228-1.449,0.375-2.199c0.087-0.373,0.167-0.75,0.373-1.132 c0.099-0.185,0.252-0.395,0.505-0.508c0.255-0.111,0.516-0.079,0.721-0.029l0.153,0.043c0.069,0.031,0.154,0.068,0.208,0.118 c0.117,0.102,0.183,0.217,0.231,0.325c0.096,0.219,0.124,0.422,0.152,0.624c0.046,0.402,0.043,0.791,0.032,1.18 c-0.027,0.775-0.101,1.542-0.166,2.31c-0.038,0.446-0.075,0.89-0.094,1.328c-0.015,0.427-0.031,0.898,0.068,1.229 c0.023,0.096,0.068,0.078,0.016,0.124l-0.002,0.004c0.005-0.031-0.007,0.046-0.005,0.034l0.001-0.009 c0.002-0.012,0-0.023-0.003-0.032c-0.005-0.008-0.025-0.04-0.013-0.042c0.007-0.002,0.028-0.015,0.055-0.05 c0.101-0.116,0.201-0.306,0.279-0.495c0.163-0.383,0.282-0.799,0.387-1.214c0.211-0.838,0.328-1.671,0.413-2.534 c0.102-0.86,0.222-1.708,0.353-2.547c0.132-0.839,0.275-1.669,0.442-2.489c0.188-0.825,0.31-1.617,0.695-2.441 c0.024-0.083,0.187-0.268,0.287-0.321c0.103-0.061,0.217-0.109,0.341-0.143c0.246-0.068,0.547-0.037,0.773,0.107 c0.454,0.3,0.593,0.776,0.676,1.19c0.074,0.426,0.063,0.846,0.015,1.253c-0.046,0.39-0.083,0.773-0.114,1.159 c-0.115,1.539-0.173,3.054-0.083,4.503c0.026,0.361,0.063,0.718,0.132,1.056c0.033,0.169,0.079,0.333,0.139,0.473 c0.029,0.069,0.066,0.135,0.1,0.171c0.033,0.076,0.063-0.018,0.059,0.106c-0.046-0.094-0.002-0.042,0.034-0.12 c0.039-0.043,0.072-0.125,0.109-0.189c0.065-0.149,0.122-0.307,0.173-0.469c0.102-0.324,0.179-0.661,0.253-0.993 c0.543-2.685,0.798-5.252,1.033-7.574l0,0.029c-0.02-0.469,0.011-0.918,0.149-1.359c0.07-0.217,0.172-0.438,0.357-0.609 c0.182-0.176,0.443-0.255,0.678-0.247l-0.051,0.005c0.368-0.065,0.635,0.158,0.788,0.378c0.157,0.227,0.227,0.473,0.281,0.71 c0.101,0.48,0.099,0.936,0.122,1.374c0.032,0.879,0.039,1.707,0.014,2.48c-0.029,1.559-0.38,2.851-0.504,3.913 c-0.159,1.062-0.278,1.887-0.329,2.442c-0.058,0.264,0.155,0.434,0.267,0.479C158.773,206.826,158.849,206.834,158.847,206.845 z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M343.781,350.901c-15.552-10.865-19.08-31.033-18.465-49.162c0.102-3.026-0.23-6.216,1.209-8.872 c1.44-2.654,4.799-4.469,7.508-3.194c2.247,1.058,3.227,3.672,4.484,5.834c1.672,2.877,4.164,5.257,7.097,6.779 c1.927,1,4.311,1.611,6.213,0.562c2.61-1.44,2.918-5.046,2.899-8.057c-0.036-5.61-0.07-11.22-0.105-16.828 c-0.019-3.009-0.028-6.083,0.908-8.939c0.936-2.856,3.004-5.51,5.867-6.312c2.864-0.802,6.404,0.849,7.009,3.795 c0.252,1.226,0.002,2.499,0.086,3.748c0.084,1.25,0.666,2.632,1.852,2.98c1.201,0.353,2.406-0.5,3.305-1.381 c3.107-3.039,5.215-6.954,7.185-10.847c1.97-3.893,3.882-7.879,6.701-11.193c2.819-3.315,6.718-5.941,11.028-6.185 c4.311-0.244,8.903,2.417,9.992,6.648c1.092,4.243-1.383,8.548-4.077,11.983c-3.996,5.096-8.724,9.602-13.988,13.333 c-0.949,0.673-1.977,1.401-2.34,2.516c-0.654,2.007,1.247,3.999,3.229,4.659c2.243,0.747,4.678,0.514,7.024,0.79 c2.347,0.276,4.889,1.311,5.777,3.529c1.233,3.076-1.34,6.301-3.871,8.413c-5.069,4.229-10.858,7.57-17.033,9.832 c-2.214,0.81-4.544,1.521-6.329,3.076c-1.785,1.556-2.863,4.261-1.784,6.38c1.079,2.123,3.848,2.801,6.167,2.37 c2.318-0.43,4.395-1.689,6.605-2.523c4.136-1.561,9.477-1.276,12.127,2.298c1.741,2.35,1.895,5.622,1.014,8.422 c-0.88,2.801-2.666,5.214-4.563,7.438c-6.629,7.777-15.115,14.039-24.711,17.366 C362.207,353.487,353.316,354.388,343.781,350.901"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M343.543,364.341c0.657-7.182,2.232-15.663,4.918-24.805 c2.668-9.149,6.425-18.935,10.705-29.036c1.079-2.521,2.146-5.012,3.197-7.467c1.055-2.448,2.101-4.876,3.271-7.188 c2.32-4.634,4.904-8.913,7.484-12.898c2.579-3.987,5.171-7.677,7.62-11.109c2.458-3.429,4.809-6.581,7.074-9.363 c4.514-5.583,8.681-9.646,11.655-12.319c1.484-1.342,2.67-2.345,3.483-3.014c0.391-0.318,0.698-0.567,0.929-0.755 c0.211-0.167,0.322-0.249,0.328-0.242c0.007,0.008-0.092,0.104-0.292,0.286c-0.222,0.198-0.518,0.462-0.894,0.797 c-0.788,0.696-1.951,1.725-3.411,3.089c-2.925,2.719-7.033,6.811-11.496,12.408c-2.24,2.79-4.567,5.948-7.004,9.383 c-2.431,3.442-5.006,7.135-7.567,11.12c-2.561,3.983-5.125,8.251-7.426,12.863c-1.16,2.3-2.194,4.708-3.25,7.163 c-1.05,2.454-2.115,4.944-3.193,7.464c-4.277,10.093-8.038,19.849-10.726,28.963c-2.704,9.106-4.312,17.545-5.016,24.696"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M365.792,295.824c-0.037,0.006-0.14-0.451-0.294-1.284c-0.158-0.832-0.347-2.042-0.558-3.541 c-0.426-2.997-0.872-7.155-1.347-11.742c-0.475-4.589-0.979-8.729-1.449-11.711c-0.231-1.491-0.43-2.697-0.578-3.528 c-0.144-0.833-0.206-1.298-0.168-1.307c0.037-0.008,0.17,0.44,0.378,1.261c0.213,0.819,0.472,2.018,0.752,3.506 c0.571,2.975,1.139,7.126,1.614,11.719c0.457,4.527,0.87,8.623,1.186,11.752c0.151,1.413,0.28,2.603,0.383,3.559 C365.799,295.349,365.831,295.818,365.792,295.824z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M404.488,288.592c0.001,0.038-0.549,0.102-1.543,0.185c-0.993,0.089-2.43,0.209-4.201,0.414 c-3.544,0.382-8.421,1.082-13.769,2.09c-5.347,1.018-10.147,2.144-13.595,3.06c-1.728,0.445-3.116,0.843-4.078,1.113 c-0.96,0.273-1.497,0.407-1.51,0.371c-0.012-0.037,0.503-0.241,1.446-0.579c0.944-0.333,2.319-0.79,4.039-1.287 c3.431-1.016,8.234-2.207,13.597-3.229c5.363-1.01,10.268-1.651,13.833-1.933c1.781-0.155,3.228-0.216,4.227-0.237 C403.933,288.544,404.486,288.553,404.488,288.592z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M348.936,338.824c-0.018,0.008-0.108-0.154-0.265-0.472c-0.179-0.379-0.397-0.841-0.662-1.4 c-0.569-1.218-1.347-3.003-2.279-5.219c-1.867-4.433-4.253-10.637-6.793-17.519c-2.542-6.885-4.867-13.103-6.639-17.568 c-0.868-2.171-1.583-3.956-2.114-5.283c-0.227-0.576-0.414-1.051-0.567-1.441c-0.124-0.331-0.181-0.509-0.163-0.518 c0.018-0.007,0.108,0.155,0.265,0.473c0.179,0.378,0.397,0.839,0.662,1.399c0.569,1.218,1.347,3.002,2.279,5.219 c1.867,4.433,4.253,10.637,6.794,17.522c2.541,6.883,4.867,13.1,6.638,17.566c0.869,2.17,1.583,3.956,2.114,5.282 c0.227,0.576,0.414,1.052,0.567,1.441C348.897,338.638,348.954,338.816,348.936,338.824z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M400.357,322.251c0.005,0.019-0.171,0.09-0.51,0.21c-0.402,0.135-0.896,0.3-1.493,0.5 c-1.379,0.447-3.241,1.051-5.506,1.784c-4.649,1.508-11.046,3.664-18.112,6.056c-7.068,2.394-13.491,4.493-18.173,5.905 c-2.341,0.707-4.24,1.259-5.56,1.614c-0.611,0.16-1.114,0.292-1.523,0.4c-0.35,0.086-0.537,0.121-0.542,0.102 c-0.005-0.019,0.171-0.09,0.51-0.211c0.401-0.134,0.895-0.299,1.493-0.499c1.379-0.447,3.24-1.05,5.505-1.784 c4.649-1.507,11.047-3.664,18.115-6.057c7.066-2.393,13.488-4.492,18.17-5.904c2.341-0.707,4.24-1.259,5.562-1.614 c0.611-0.16,1.113-0.293,1.523-0.4C400.165,322.268,400.351,322.233,400.357,322.251z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M325.394,395.775l-107.884-0.499c-12.975-0.059-23.447-10.624-23.392-23.6l1.143-270.469 c0.055-12.983,10.626-23.461,23.609-23.402l107.885,0.498c12.975,0.06,23.446,10.625,23.392,23.6l-1.143,270.47 C348.948,385.357,338.377,395.835,325.394,395.775z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M326.601,87.104l-20.917-0.096c-2.805-0.013-5.09,2.354-5.101,5.286l-0.017,3.794 c-0.012,2.932-2.296,5.299-5.101,5.286l-40.772-0.188c-2.805-0.013-5.069-2.401-5.057-5.333l0.016-3.794 c0.012-2.932-2.252-5.32-5.057-5.333l-7.356-0.034l-18.307-0.084c-9.092-0.042-16.496,7.297-16.534,16.389l-1.116,263.997 c-0.038,9.088,7.295,16.487,16.382,16.529l107.669,0.497c9.091,0.042,16.495-7.296,16.534-16.389l1.116-263.998 C343.021,94.545,335.688,87.146,326.601,87.104z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M332.453,323.228H211.811c-3.194,0-5.784-2.59-5.784-5.784V145.675 c0-3.194,2.59-5.784,5.784-5.784h120.642c3.194,0,5.784,2.589,5.784,5.784v171.769 C338.237,320.638,335.648,323.228,332.453,323.228z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8505B"
    },
    d: "M258.439,181.346l-26.892,61.597c-3.558,8.151,2.977,17.116,11.825,16.219 c18.684-1.895,46.68-4.781,66.084-6.786c9.628-0.995,14.423-12.171,8.513-19.837l-41.211-53.451 C271.78,172.632,261.701,173.874,258.439,181.346z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.823,185.485c-0.025-0.011,0.05-0.213,0.222-0.602c0.09-0.192,0.188-0.441,0.34-0.717 c0.175-0.268,0.376-0.575,0.602-0.922c0.244-0.338,0.575-0.673,0.912-1.066c0.398-0.326,0.789-0.752,1.316-1.072 c0.997-0.72,2.334-1.314,3.919-1.587c1.579-0.271,3.436-0.194,5.288,0.509c0.903,0.391,1.833,0.865,2.651,1.565 c0.205,0.174,0.412,0.349,0.621,0.526c0.191,0.194,0.371,0.405,0.559,0.61c0.391,0.413,0.713,0.843,1.057,1.279 c2.737,3.493,5.85,7.468,9.291,11.861c6.858,8.816,15.019,19.308,24.079,30.956c1.13,1.462,2.273,2.941,3.43,4.438 c1.226,1.59,2.045,3.539,2.318,5.584c0.572,4.089-1.17,8.537-4.65,11.112c-1.716,1.297-3.828,2.087-5.983,2.309 c-2.031,0.21-4.079,0.422-6.142,0.636c-4.126,0.425-8.312,0.856-12.548,1.292c-8.476,0.865-16.751,1.709-24.743,2.525 c-3.996,0.404-7.922,0.8-11.766,1.189c-0.961,0.097-1.917,0.193-2.868,0.289l-1.423,0.142l-1.517,0.048 c-2.022-0.063-4.005-0.691-5.653-1.778c-3.329-2.154-5.261-6.019-5.106-9.755c0.046-0.464,0.045-0.932,0.133-1.386 c0.1-0.451,0.184-0.905,0.3-1.347l0.466-1.285c0.164-0.41,0.342-0.786,0.511-1.178c0.685-1.551,1.359-3.079,2.022-4.58 c2.657-6.001,5.133-11.592,7.394-16.697c4.532-10.203,8.223-18.449,10.807-24.133c1.301-2.822,2.315-5.02,3.011-6.53 C259.38,186.233,259.773,185.463,259.823,185.485c0.049,0.021-0.248,0.834-0.859,2.36c-0.634,1.537-1.557,3.774-2.742,6.647 c-2.412,5.759-5.95,14.072-10.352,24.332c-2.207,5.129-4.624,10.745-7.219,16.774c-0.651,1.507-1.312,3.039-1.984,4.596 c-0.164,0.387-0.347,0.784-0.497,1.169l-0.403,1.137c-0.098,0.39-0.167,0.789-0.254,1.185 c-0.076,0.398-0.067,0.808-0.108,1.213c-0.116,3.261,1.603,6.643,4.515,8.504c1.44,0.939,3.157,1.473,4.917,1.52l1.324-0.048 l1.421-0.148c0.95-0.1,1.906-0.2,2.867-0.3c3.843-0.401,7.767-0.81,11.762-1.227c7.991-0.826,16.264-1.68,24.738-2.556 c4.236-0.434,8.422-0.862,12.548-1.284c2.063-0.21,4.111-0.419,6.142-0.626c1.91-0.196,3.725-0.875,5.223-1.997 c3.033-2.223,4.578-6.13,4.089-9.692c-0.233-1.783-0.932-3.483-2.01-4.894c-1.147-1.499-2.28-2.981-3.4-4.445 c-8.961-11.725-17.031-22.286-23.814-31.161c-3.373-4.445-6.425-8.467-9.108-12.002c-0.335-0.442-0.659-0.889-1-1.259 c-0.169-0.192-0.33-0.39-0.502-0.573c-0.189-0.166-0.376-0.331-0.561-0.493c-0.737-0.661-1.584-1.113-2.41-1.496 c-1.696-0.689-3.426-0.809-4.918-0.599c-1.497,0.212-2.782,0.727-3.758,1.374c-0.517,0.283-0.903,0.674-1.304,0.967 c-0.34,0.361-0.677,0.665-0.933,0.977c-0.244,0.321-0.46,0.605-0.647,0.852c-0.17,0.257-0.288,0.488-0.4,0.665 C259.971,185.315,259.847,185.496,259.823,185.485z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M264.131,199.563l4.014,24.548c0.328,2.007,2.101,3.455,4.134,3.375l0,0 c2.144-0.085,3.845-1.835,3.869-3.98l0.28-25.099c0.021-1.901-1.628-3.39-3.516-3.176l-6.017,0.682 C265.099,196.116,263.84,197.78,264.131,199.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M279.691,239.78c-0.736,3.264-3.978,5.314-7.242,4.578 c-3.264-0.736-5.314-3.978-4.578-7.242c0.736-3.264,3.978-5.314,7.243-4.578C278.376,233.273,280.426,236.516,279.691,239.78z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8505B"
    },
    d: "M229.829,166.775l-20.025,18.313c-2.65,2.423-1.709,6.803,1.702,7.923 c7.204,2.366,18.005,5.893,25.493,8.336c3.715,1.212,7.317-2.124,6.394-5.922l-6.436-26.479 C236.18,165.748,232.258,164.553,229.829,166.775z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M229.661,168.529c-0.023-0.02,0.168-0.343,0.753-0.719c0.568-0.363,1.63-0.765,2.97-0.458 c0.658,0.153,1.37,0.49,1.979,1.075c0.61,0.567,1.048,1.484,1.244,2.363c0.458,1.738,0.977,3.709,1.549,5.884 c1.114,4.382,2.436,9.579,3.903,15.346c0.18,0.725,0.362,1.459,0.546,2.202c0.21,0.855,0.195,1.79-0.06,2.666 c-0.501,1.756-1.992,3.235-3.863,3.656c-0.926,0.218-1.93,0.158-2.831-0.137c-0.784-0.255-1.575-0.512-2.371-0.77 c-1.592-0.519-3.207-1.046-4.842-1.579c-3.268-1.074-6.458-2.123-9.54-3.136c-1.539-0.51-3.051-1.011-4.532-1.502 c-0.37-0.123-0.738-0.246-1.104-0.367l-0.548-0.183l-0.62-0.254c-0.805-0.391-1.495-1.006-1.963-1.743 c-0.953-1.471-1.032-3.371-0.293-4.849c0.181-0.372,0.415-0.706,0.668-1.02l0.418-0.43l0.387-0.351 c0.51-0.457,1.012-0.907,1.505-1.349c1.977-1.761,3.819-3.403,5.505-4.905c3.374-2.99,6.122-5.389,8.045-7.021 C228.49,169.314,229.588,168.449,229.661,168.529s-0.886,1.096-2.683,2.866c-1.797,1.77-4.432,4.294-7.71,7.388 c-1.646,1.545-3.446,3.234-5.376,5.046c-0.485,0.452-0.977,0.912-1.478,1.379l-0.37,0.349l-0.3,0.321 c-0.177,0.233-0.343,0.475-0.467,0.743c-0.51,1.059-0.429,2.432,0.261,3.465c0.339,0.517,0.823,0.938,1.395,1.208 l0.444,0.176l0.549,0.176c0.367,0.118,0.737,0.237,1.108,0.356c1.485,0.479,3.001,0.968,4.544,1.466 c3.085,1.003,6.278,2.042,9.548,3.106c1.633,0.536,3.248,1.065,4.839,1.587c0.795,0.262,1.585,0.522,2.368,0.779 c0.668,0.218,1.353,0.26,2.01,0.113c1.319-0.281,2.411-1.345,2.773-2.586c0.186-0.62,0.209-1.28,0.062-1.91 c-0.174-0.74-0.346-1.472-0.516-2.195c-1.344-5.797-2.556-11.021-3.577-15.425c-0.49-2.194-0.933-4.184-1.324-5.938 c-0.164-0.873-0.449-1.52-0.929-2.05c-0.472-0.51-1.05-0.834-1.604-1.008c-1.126-0.35-2.094-0.102-2.665,0.149 C229.975,168.347,229.709,168.587,229.661,168.529z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M228.941,174.429l-2.546,9.715c-0.208,0.794,0.209,1.619,0.972,1.923l0,0 c0.805,0.321,1.719-0.046,2.08-0.834l4.22-9.214c0.32-0.698-0.044-1.518-0.776-1.748l-2.332-0.735 C229.863,173.316,229.126,173.724,228.941,174.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M228.084,191.818c-0.807,1.084-2.339,1.308-3.423,0.501 c-1.084-0.807-1.308-2.339-0.501-3.423c0.807-1.083,2.339-1.308,3.423-0.501C228.667,189.202,228.891,190.735,228.084,191.818 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8505B"
    },
    d: "M306.669,172.456l-4.543,20.705c-0.601,2.74,1.971,5.113,4.653,4.292 c5.664-1.732,14.148-4.341,20.028-6.151c2.918-0.898,3.716-4.65,1.417-6.659l-16.027-14.009 C310.262,168.942,307.22,169.945,306.669,172.456z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M307.351,173.652c-0.035-0.005-0.07-0.3,0.127-0.814c0.192-0.497,0.688-1.252,1.698-1.676 c0.497-0.207,1.116-0.32,1.786-0.222c0.658,0.082,1.382,0.486,1.906,0.957c1.082,0.901,2.306,1.919,3.654,3.04 c2.695,2.292,5.885,5.005,9.423,8.014c0.442,0.382,0.89,0.768,1.343,1.159c0.539,0.467,0.968,1.096,1.209,1.796 c0.491,1.401,0.194,3.079-0.851,4.237c-0.513,0.58-1.211,1.011-1.944,1.236c-0.615,0.191-1.235,0.383-1.86,0.576 c-1.25,0.385-2.518,0.776-3.802,1.172c-2.57,0.784-5.079,1.549-7.503,2.288c-1.213,0.366-2.404,0.725-3.571,1.077 l-0.871,0.261l-0.433,0.129l-0.531,0.121c-0.718,0.117-1.466,0.03-2.122-0.241c-1.322-0.533-2.26-1.758-2.46-3.086 c-0.053-0.331-0.054-0.663-0.032-0.989l0.076-0.48l0.09-0.4c0.121-0.521,0.241-1.034,0.358-1.538 c0.476-2.011,0.921-3.887,1.327-5.605c0.824-3.424,1.516-6.189,2.03-8.092C306.912,174.67,307.245,173.629,307.351,173.652 c0.105,0.023-0.028,1.109-0.358,3.052c-0.331,1.943-0.859,4.744-1.545,8.199c-0.35,1.731-0.732,3.62-1.141,5.646 c-0.104,0.507-0.211,1.023-0.318,1.547l-0.078,0.388l-0.044,0.323c-0.007,0.216-0.003,0.433,0.037,0.647 c0.146,0.854,0.781,1.647,1.636,1.973c0.424,0.167,0.892,0.212,1.35,0.131l0.342-0.083l0.429-0.135l0.867-0.273 c1.163-0.364,2.351-0.735,3.559-1.113c2.421-0.749,4.926-1.524,7.493-2.318c1.284-0.393,2.553-0.781,3.804-1.164 c0.626-0.19,1.247-0.379,1.863-0.567c0.499-0.153,0.926-0.417,1.259-0.783c0.675-0.726,0.884-1.834,0.577-2.735 c-0.15-0.452-0.414-0.86-0.772-1.18c-0.443-0.395-0.882-0.785-1.315-1.171c-3.455-3.104-6.57-5.902-9.202-8.266 c-1.292-1.186-2.464-2.262-3.501-3.214c-0.9-0.972-2.053-1.099-2.908-0.822c-0.86,0.266-1.368,0.841-1.626,1.248 C307.493,173.399,307.419,173.669,307.351,173.652z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M309.547,177.743l2.747,7.348c0.225,0.601,0.862,0.94,1.486,0.79l0,0 c0.658-0.158,1.077-0.803,0.953-1.468l-1.453-7.782c-0.11-0.589-0.711-0.949-1.283-0.767l-1.82,0.58 C309.635,176.617,309.347,177.209,309.547,177.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M316.826,189.231c-0.027,1.055-0.905,1.888-1.96,1.86 c-1.055-0.027-1.888-0.905-1.86-1.96c0.027-1.055,0.905-1.888,1.96-1.861C316.021,187.298,316.854,188.176,316.826,189.231z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M221.71,264.138c-0.026,0.025-0.275-0.206-0.705-0.648c-0.219-0.217-0.477-0.493-0.744-0.84 c-0.271-0.343-0.603-0.72-0.901-1.185c-0.645-0.897-1.303-2.042-1.92-3.368c-0.591-1.337-1.125-2.862-1.491-4.512 c-0.346-1.655-0.488-3.264-0.501-4.727c0.016-1.463,0.143-2.778,0.362-3.861c0.081-0.546,0.227-1.026,0.333-1.451 c0.101-0.426,0.222-0.784,0.332-1.072c0.21-0.579,0.342-0.892,0.375-0.88c0.095,0.031-0.357,1.315-0.677,3.463 c-0.169,1.072-0.256,2.364-0.246,3.796c0.039,1.431,0.191,3.002,0.53,4.621c0.358,1.614,0.866,3.108,1.421,4.428 c0.58,1.309,1.192,2.45,1.787,3.358C220.844,263.086,221.784,264.071,221.71,264.138z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M230.42,265.398c-0.021,0.029-0.324-0.164-0.856-0.542c-0.27-0.184-0.591-0.422-0.934-0.735 c-0.346-0.308-0.763-0.638-1.158-1.07c-0.837-0.818-1.725-1.901-2.593-3.183c-0.841-1.3-1.647-2.81-2.285-4.483 c-0.616-1.682-0.999-3.35-1.216-4.884c-0.186-1.538-0.225-2.938-0.13-4.104c0.014-0.585,0.113-1.107,0.172-1.567 c0.054-0.461,0.14-0.851,0.223-1.167c0.154-0.634,0.255-0.979,0.29-0.97c0.102,0.021-0.244,1.423-0.318,3.722 c-0.047,1.148,0.03,2.518,0.237,4.02c0.239,1.497,0.626,3.124,1.229,4.768c0.624,1.636,1.398,3.117,2.199,4.404 c0.828,1.269,1.668,2.354,2.457,3.19C229.303,264.483,230.483,265.315,230.42,265.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M323.43,254.75c-0.087-0.046,0.691-1.441,1.574-3.842c0.449-1.197,0.878-2.66,1.25-4.306 c0.344-1.652,0.615-3.49,0.719-5.435c0.083-1.947-0.01-3.803-0.195-5.48c-0.212-1.674-0.499-3.171-0.832-4.406 c-0.649-2.474-1.29-3.937-1.199-3.975c0.033-0.014,0.212,0.341,0.509,1c0.307,0.654,0.672,1.637,1.045,2.876 c0.382,1.237,0.712,2.748,0.953,4.444c0.214,1.7,0.324,3.587,0.239,5.566c-0.105,1.977-0.395,3.844-0.771,5.516 c-0.403,1.666-0.875,3.138-1.374,4.332c-0.49,1.197-0.947,2.141-1.316,2.763C323.673,254.43,323.461,254.768,323.43,254.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M331.457,252.691c-0.085-0.045,0.539-1.185,1.207-3.15c0.341-0.979,0.651-2.177,0.902-3.521 c0.226-1.349,0.377-2.849,0.375-4.428c-0.02-1.58-0.194-3.077-0.439-4.423c-0.27-1.341-0.597-2.534-0.952-3.508 c-0.696-1.955-1.336-3.085-1.252-3.132c0.031-0.018,0.211,0.252,0.512,0.758c0.31,0.501,0.687,1.268,1.085,2.244 c0.406,0.974,0.777,2.179,1.078,3.544c0.277,1.369,0.468,2.899,0.489,4.514c0.003,1.614-0.167,3.147-0.424,4.519 c-0.282,1.368-0.635,2.579-1.027,3.558c-0.383,0.981-0.75,1.754-1.052,2.259C331.665,252.436,331.489,252.708,331.457,252.691 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#E8505B",
      strokeMiterlimit: 10
    },
    d: "M326.313,309.657H222.335c-2.333,0-4.225-1.892-4.225-4.225 v-20.676c0-2.333,1.891-4.225,4.225-4.225h103.978c2.333,0,4.225,1.892,4.225,4.225v20.676 C330.538,307.766,328.646,309.657,326.313,309.657z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 254.7521 298.6222)",
    style: {
      fill: "#E8505B",
      fontFamily: "'Montserrat-Regular'",
      fontSize: 12
    }
  }, "ALERT")), /*#__PURE__*/React.createElement("rect", {
    x: 206.028,
    y: 132.015,
    style: {
      fill: "#E0E0E0"
    },
    width: 132.21,
    height: 18.161
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 214.175,
    cy: 141.262,
    r: 2.489
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 224.381,
    cy: 141.262,
    r: 2.489
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M237.075,141.262c0,1.374-1.114,2.489-2.489,2.489c-1.374,0-2.489-1.114-2.489-2.489 s1.114-2.489,2.489-2.489C235.961,138.773,237.075,139.887,237.075,141.262z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M129.179,164.787c-1.036-0.255-6.026-1.481-15.679-3.853l0.115-0.018 c-3.448,2.199-8.119,3.974-13.534,4.058c-2.694-0.01-5.543-0.334-8.387-1.225c-2.841-0.885-5.635-2.353-8.173-4.333 c-5.08-3.929-9.035-10.227-9.889-17.475c-0.436-3.6-0.144-7.386,0.976-11.01c1.141-3.615,3.109-7.04,5.761-9.923 c1.344-1.523,2.926-2.788,4.541-3.956c0.848-0.523,1.683-1.067,2.557-1.527l1.333-0.642l0.665-0.319l0.691-0.253 c3.654-1.417,7.541-1.965,11.273-1.717c3.736,0.24,7.314,1.286,10.444,2.932c3.135,1.643,5.823,3.875,7.933,6.408 c2.116,2.534,3.653,5.367,4.631,8.227c0.978,2.864,1.423,5.744,1.449,8.465c0.033,5.467-1.676,10.158-3.756,13.582l0.002-0.141 C126.49,159.935,128.693,163.91,129.179,164.787c-0.503-0.867-2.782-4.799-7.293-12.58l-0.041-0.07l0.043-0.072 c2.027-3.407,3.679-8.046,3.618-13.435c-0.04-2.683-0.493-5.516-1.466-8.329c-0.974-2.81-2.496-5.589-4.583-8.073 c-2.082-2.483-4.727-4.667-7.808-6.273c-3.076-1.609-6.587-2.627-10.252-2.857c-3.662-0.238-7.472,0.304-11.052,1.695 l-0.677,0.248l-0.651,0.314l-1.307,0.63c-0.856,0.451-1.675,0.986-2.506,1.498c-1.582,1.147-3.134,2.386-4.451,3.88 c-2.599,2.826-4.529,6.182-5.651,9.724c-1.101,3.551-1.391,7.263-0.968,10.796c0.827,7.109,4.691,13.297,9.671,17.174 c2.488,1.953,5.229,3.406,8.02,4.288c2.794,0.887,5.597,1.219,8.251,1.243c5.336-0.056,9.954-1.774,13.382-3.92l0.055-0.034 l0.061,0.016C123.181,163.196,128.149,164.514,129.179,164.787z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8505B"
    },
    d: "M97.509,127.122l0.829,13.097c0.068,1.071,0.923,1.923,1.994,1.987l0,0 c1.13,0.067,2.114-0.763,2.239-1.888l1.454-13.163c0.11-0.997-0.678-1.865-1.681-1.851l-3.195,0.045 C98.197,125.363,97.449,126.171,97.509,127.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8505B"
    },
    d: "M103.804,149.573c-0.556,1.676-2.365,2.583-4.041,2.027c-1.675-0.556-2.583-2.365-2.027-4.041 c0.556-1.676,2.365-2.583,4.041-2.027C103.453,146.089,104.361,147.898,103.804,149.573z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.1f58af943412c4f516c2e67444b98df0.svg";
export { ForwardRef as ReactComponent };